import React, { useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import { postImage, uploadAnexo } from '../../services/api-auto';
import styles from './styles.module.scss';

const ButtonsAnexo = ({
  changeImage,
  texto,
  formatos = ['application/pdf'],
  tamanho,
  nomeArquivo,
  modalLoading,
}) => {
  const ref = useRef();
  const [error, setError] = useState('');
  const [nomeAnexo, setNomeAnexo] = useState('');

  const onImageChange = async (event) => {
    let file;
    setError('');
    if (event.target.files && event.target.files[0]) {
      file = event.target.files[0];

      modalLoading(true);
      var link = await uploadAnexo(file);
      changeImage(link.data, file.name);
      setNomeAnexo(file);
      modalLoading(false);
    }
  };

  const callImageInput = () => {
    ref.current.click();
  };

  return (
    <div className={styles.imageWrapper}>
      <input
        type="file"
        onChange={onImageChange}
        style={{ display: 'none' }}
        ref={ref}
      />
      <button onClick={callImageInput}>
        <div className={styles.imageWrapperIcon}>
          <FontAwesomeIcon icon={faUpload} />
        </div>
        <div className={styles.imageButtonWrapperText}>
          <div className={styles.imageWrapperTexto}>
            {nomeArquivo
              ? 'Arquivo selecionado'
              : !texto
              ? 'Escolher arquivo'
              : texto}
            <br />
            <small>{nomeArquivo}</small>
          </div>
        </div>
      </button>
      {error && <div className={styles.messageError}>{error}</div>}
      <div className={styles.imageWrapperDetalhes}>
        Formato: PDF, PPT ou WAV
      </div>
      {tamanho && (
        <div className={styles.imageWrapperDetalhes}>
          Tamanho máx.: {tamanho}
        </div>
      )}
    </div>
  );
};

export default ButtonsAnexo;
